import { useEffect, useState } from "react";
import { Spin, message } from "antd";
import { serverFetch } from "../../../server";

const ReportPreview = () => {
  const [loading, setLoading] = useState(true);
  const [reportData, setReportData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadReport = async () => {
      try {
        setLoading(true);
        setError(null);

        // Получаем параметры из URL
        const urlParams = new URLSearchParams(window.location.search);
        const queryString = urlParams.toString();

        if (!queryString) {
          setError("Не указаны параметры для отчета");
          return;
        }

        // Запрос к API
        const data = await serverFetch(`report/design?${queryString}`);
        
        setReportData({html: data});
      } catch (e) {
        console.error("Ошибка загрузки отчета:", e);
        setError(e.userMessage || "Ошибка загрузки отчета");
        message.error(e.userMessage || "Ошибка загрузки отчета");
      } finally {
        setLoading(false);
      }
    };

    loadReport();
  }, []);

  if (loading) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        flexDirection: "column",
        gap: 16
      }}>
        <Spin size="large" />
        <div style={{ fontSize: 16, color: "#666" }}>Загрузка отчета...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        flexDirection: "column",
        gap: 16
      }}>
        <div style={{ fontSize: 18, color: "#ff4d4f" }}>Ошибка</div>
        <div style={{ fontSize: 14, color: "#666" }}>{error}</div>
      </div>
    );
  }

  if (!reportData) {
    return (
      <div style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center", 
        height: "100vh",
        flexDirection: "column",
        gap: 16
      }}>
        <div style={{ fontSize: 18, color: "#666" }}>Данные не найдены</div>
      </div>
    );
  }

  // Если данные содержат HTML, отображаем их
  if (reportData.html) {
    return (
      <div 
        style={{ 
          width: "100%", 
          minHeight: "100vh",
          padding: 0,
          margin: 0
        }}
        dangerouslySetInnerHTML={{ __html: reportData.html }}
      />
    );
  }

  // Если данные содержат текст, отображаем как текст
  if (reportData.text) {
    return (
      <div style={{ 
        padding: 20,
        fontFamily: "monospace",
        whiteSpace: "pre-wrap",
        backgroundColor: "#f5f5f5",
        minHeight: "100vh"
      }}>
        {reportData.text}
      </div>
    );
  }

  // Если данные содержат JSON, отображаем как JSON
  if (reportData.data) {
    return (
      <div style={{ 
        padding: 20,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh"
      }}>
        <pre style={{ 
          fontSize: 12,
          fontFamily: "monospace",
          whiteSpace: "pre-wrap",
          backgroundColor: "white",
          padding: 16,
          borderRadius: 4,
          border: "1px solid #d9d9d9"
        }}>
          {JSON.stringify(reportData.data, null, 2)}
        </pre>
      </div>
    );
  }

  // Если данные содержат массив элементов отчета, отображаем их
  if (Array.isArray(reportData)) {
    return (
      <div style={{ 
        padding: 20,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh"
      }}>
        {reportData.map((item, index) => (
          <div key={index} style={{
            backgroundColor: "white",
            padding: 16,
            marginBottom: 16,
            borderRadius: 4,
            border: "1px solid #d9d9d9"
          }}>
            <h3 style={{ margin: "0 0 8px 0", fontSize: 16 }}>
              {item.name || `Элемент ${index + 1}`}
            </h3>
            <div style={{ fontSize: 12, color: "#666", marginBottom: 8 }}>
              Тип: {item.$type === "data" ? "SQL Запрос" : "HTML Дизайн"}
            </div>
            {item.$type === "data" && item.sql && (
              <pre style={{
                fontSize: 11,
                backgroundColor: "#f5f5f5",
                padding: 8,
                borderRadius: 4,
                margin: 0,
                overflow: "auto"
              }}>
                {item.sql}
              </pre>
            )}
            {item.$type === "view" && item.body && (
              <div dangerouslySetInnerHTML={{ __html: item.body }} />
            )}
          </div>
        ))}
      </div>
    );
  }

  // Если данные содержат объект с полями отчета
  if (reportData.name) {
    return (
      <div style={{ 
        padding: 20,
        backgroundColor: "#f5f5f5",
        minHeight: "100vh"
      }}>
        <div style={{
          backgroundColor: "white",
          padding: 20,
          borderRadius: 4,
          border: "1px solid #d9d9d9"
        }}>
          <h1 style={{ margin: "0 0 16px 0", fontSize: 24 }}>
            {reportData.name}
          </h1>
          {reportData.description && (
            <p style={{ fontSize: 14, color: "#666", margin: "0 0 16px 0" }}>
              {reportData.description}
            </p>
          )}
          <div style={{ fontSize: 12, color: "#999", marginBottom: 20 }}>
            Вид: {reportData.vid === 1 ? "Клиент" : reportData.vid === 2 ? "Запись" : reportData.vid === 3 ? "Визит" : reportData.vid}
          </div>
          {reportData.body && Array.isArray(reportData.body) && (
            <div>
              <h3 style={{ fontSize: 16, margin: "0 0 12px 0" }}>Элементы отчета:</h3>
              {reportData.body.map((item, index) => (
                <div key={index} style={{
                  backgroundColor: "#f9f9f9",
                  padding: 12,
                  marginBottom: 8,
                  borderRadius: 4,
                  border: "1px solid #e8e8e8"
                }}>
                  <div style={{ fontWeight: "bold", marginBottom: 4 }}>
                    {item.name || `Элемент ${index + 1}`}
                  </div>
                  <div style={{ fontSize: 12, color: "#666", marginBottom: 4 }}>
                    Тип: {item.$type === "data" ? "SQL Запрос" : "HTML Дизайн"}
                  </div>
                  {item.$type === "data" && item.sql && (
                    <pre style={{
                      fontSize: 10,
                      backgroundColor: "#f0f0f0",
                      padding: 6,
                      borderRadius: 2,
                      margin: 0,
                      overflow: "auto",
                      maxHeight: 100
                    }}>
                      {item.sql}
                    </pre>
                  )}
                  {item.$type === "view" && item.body && (
                    <div style={{ fontSize: 12 }}>
                      <div style={{ color: "#666", marginBottom: 4 }}>HTML Body:</div>
                      <div style={{ 
                        backgroundColor: "#f0f0f0", 
                        padding: 6, 
                        borderRadius: 2,
                        fontFamily: "monospace",
                        fontSize: 10,
                        maxHeight: 100,
                        overflow: "auto"
                      }}>
                        {item.body}
                      </div>
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Fallback - отображаем данные как есть
  return (
    <div style={{ 
      padding: 20,
      backgroundColor: "#f5f5f5",
      minHeight: "100vh"
    }}>
      <pre style={{ 
        fontSize: 12,
        fontFamily: "monospace",
        whiteSpace: "pre-wrap",
        backgroundColor: "white",
        padding: 16,
        borderRadius: 4,
        border: "1px solid #d9d9d9"
      }}>
        {JSON.stringify(reportData, null, 2)}
      </pre>
    </div>
  );
};

export default ReportPreview;
